// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LegalPage-page-NIazy {
  --red: #e8232b;
  --ink: #0f1214;
  --muted: #5a6168;
  --line: #e7e9ec;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #0f1214;
  color: var(--ink);
  background: #fff;
}

.LegalPage-wrap-N4GQg {
  max-width: 1080px;
  margin: 0 auto;
  padding: 0 24px;
}

.LegalPage-hero-KyoLk {
  background: radial-gradient(circle at 88% 10%, #fff0ef, transparent 42%), #fafbfc;
  border-bottom: 1px solid var(--line);
  padding: 56px 0 40px;
}

.LegalPage-eyebrow-YyUCh {
  display: inline-block;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  /* A11Y (WCAG 2.1 AA 1.4.3): #e8232b is 4.46:1 on white (fails 4.5:1 for this
     small uppercase label). Darkened to #c2151c (6.14:1) — same brand hue. */
  color: #c2151c;
  margin-bottom: 12px;
}

.LegalPage-h1-_ewbi {
  font-size: clamp(30px, 5vw, 46px);
  font-weight: 800;
  line-height: 1.08;
  margin: 0 0 14px;
  max-width: 760px;
}

.LegalPage-updated-eTnsM {
  font-size: 14px;
  color: var(--muted);
  margin: 0 0 18px;
}

.LegalPage-intro-iBdaU {
  font-size: clamp(16px, 2.2vw, 19px);
  line-height: 1.6;
  color: #3a424b;
  max-width: 760px;
  margin: 0;
}

.LegalPage-layout-R8mm6 {
  display: grid;
  grid-template-columns: 248px 1fr;
  gap: 48px;
  padding: 44px 0 72px;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: start;
}

.LegalPage-layoutNarrow-Qr92T {
  max-width: 760px;
  padding: 44px 0 72px;
}

/* Table of contents */

.LegalPage-toc-js6aU {
  position: sticky;
  top: 24px;
  border: 1px solid var(--line);
  border-radius: 16px;
  padding: 20px 18px;
  background: #fff;
}

.LegalPage-tocTitle-fHJLm {
  display: block;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--muted);
  margin-bottom: 12px;
}

.LegalPage-toc-js6aU ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.LegalPage-toc-js6aU li {
  margin: 0 0 9px;
}

.LegalPage-toc-js6aU a {
  font-size: 14px;
  line-height: 1.4;
  color: #444b52;
  text-decoration: none;
  -webkit-transition: color 0.15s;
  transition: color 0.15s;
}

.LegalPage-toc-js6aU a:hover {
  color: var(--red);
}

/* Body */

.LegalPage-body-JLv8p {
  min-width: 0;
}

.LegalPage-section-xKjub {
  scroll-margin-top: 24px;
  margin-bottom: 38px;
}

.LegalPage-h2-pdrc5 {
  font-size: clamp(21px, 3vw, 26px);
  font-weight: 800;
  margin: 0 0 14px;
  padding-top: 6px;
}

.LegalPage-subH-y3ppp {
  font-size: 17px;
  font-weight: 700;
  margin: 22px 0 8px;
}

.LegalPage-body-JLv8p p {
  font-size: 16px;
  line-height: 1.7;
  color: #353c44;
  margin: 0 0 14px;
}

.LegalPage-list-mbIQp {
  margin: 0 0 16px;
  padding-left: 22px;
}

.LegalPage-list-mbIQp li {
  font-size: 16px;
  line-height: 1.65;
  color: #353c44;
  margin-bottom: 8px;
}

.LegalPage-note-Co2Hu {
  background: #fff7f0;
  border-left: 3px solid #f5a623;
  border-radius: 8px;
  padding: 14px 16px;
  font-size: 15px !important;
  color: #5a4a2e !important;
}

@media (max-width: 880px) {
  .LegalPage-layout-R8mm6 {
    grid-template-columns: 1fr;
    gap: 0;
  }
  .LegalPage-toc-js6aU {
    position: static;
    margin-bottom: 28px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/routes/legal/LegalPage.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,uFAAuF;EACvF,cAAiB;EAAjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iFAAiF;EACjF,oCAAoC;EACpC,oBAAoB;AACtB;;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB;6EAC2E;EAC3E,cAAc;EACd,mBAAmB;AACrB;;AACA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,oBAAoB;EACpB,wBAAkB;MAAlB,qBAAkB;UAAlB,kBAAkB;AACpB;;AACA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,sBAAsB;;AACtB;EACE,gBAAgB;EAChB,SAAS;EACT,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AACA;EACE,eAAe;AACjB;;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,+BAAuB;EAAvB,uBAAuB;AACzB;;AACA;EACE,iBAAiB;AACnB;;AAEA,SAAS;;AACT;EACE,YAAY;AACd;;AACA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AACA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AACA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE;IACE,0BAA0B;IAC1B,MAAM;EACR;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;AACF","sourcesContent":[".page {\n  --red: #e8232b;\n  --ink: #0f1214;\n  --muted: #5a6168;\n  --line: #e7e9ec;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  color: var(--ink);\n  background: #fff;\n}\n\n.wrap {\n  max-width: 1080px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n.hero {\n  background: radial-gradient(circle at 88% 10%, #fff0ef, transparent 42%), #fafbfc;\n  border-bottom: 1px solid var(--line);\n  padding: 56px 0 40px;\n}\n.eyebrow {\n  display: inline-block;\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  /* A11Y (WCAG 2.1 AA 1.4.3): #e8232b is 4.46:1 on white (fails 4.5:1 for this\n     small uppercase label). Darkened to #c2151c (6.14:1) — same brand hue. */\n  color: #c2151c;\n  margin-bottom: 12px;\n}\n.h1 {\n  font-size: clamp(30px, 5vw, 46px);\n  font-weight: 800;\n  line-height: 1.08;\n  margin: 0 0 14px;\n  max-width: 760px;\n}\n.updated {\n  font-size: 14px;\n  color: var(--muted);\n  margin: 0 0 18px;\n}\n.intro {\n  font-size: clamp(16px, 2.2vw, 19px);\n  line-height: 1.6;\n  color: #3a424b;\n  max-width: 760px;\n  margin: 0;\n}\n\n.layout {\n  display: grid;\n  grid-template-columns: 248px 1fr;\n  gap: 48px;\n  padding: 44px 0 72px;\n  align-items: start;\n}\n.layoutNarrow {\n  max-width: 760px;\n  padding: 44px 0 72px;\n}\n\n/* Table of contents */\n.toc {\n  position: sticky;\n  top: 24px;\n  border: 1px solid var(--line);\n  border-radius: 16px;\n  padding: 20px 18px;\n  background: #fff;\n}\n.tocTitle {\n  display: block;\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--muted);\n  margin-bottom: 12px;\n}\n.toc ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.toc li {\n  margin: 0 0 9px;\n}\n.toc a {\n  font-size: 14px;\n  line-height: 1.4;\n  color: #444b52;\n  text-decoration: none;\n  transition: color 0.15s;\n}\n.toc a:hover {\n  color: var(--red);\n}\n\n/* Body */\n.body {\n  min-width: 0;\n}\n.section {\n  scroll-margin-top: 24px;\n  margin-bottom: 38px;\n}\n.h2 {\n  font-size: clamp(21px, 3vw, 26px);\n  font-weight: 800;\n  margin: 0 0 14px;\n  padding-top: 6px;\n}\n.subH {\n  font-size: 17px;\n  font-weight: 700;\n  margin: 22px 0 8px;\n}\n.body p {\n  font-size: 16px;\n  line-height: 1.7;\n  color: #353c44;\n  margin: 0 0 14px;\n}\n.list {\n  margin: 0 0 16px;\n  padding-left: 22px;\n}\n.list li {\n  font-size: 16px;\n  line-height: 1.65;\n  color: #353c44;\n  margin-bottom: 8px;\n}\n.note {\n  background: #fff7f0;\n  border-left: 3px solid #f5a623;\n  border-radius: 8px;\n  padding: 14px 16px;\n  font-size: 15px !important;\n  color: #5a4a2e !important;\n}\n\n@media (max-width: 880px) {\n  .layout {\n    grid-template-columns: 1fr;\n    gap: 0;\n  }\n  .toc {\n    position: static;\n    margin-bottom: 28px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `LegalPage-page-NIazy`,
	"wrap": `LegalPage-wrap-N4GQg`,
	"hero": `LegalPage-hero-KyoLk`,
	"eyebrow": `LegalPage-eyebrow-YyUCh`,
	"h1": `LegalPage-h1-_ewbi`,
	"updated": `LegalPage-updated-eTnsM`,
	"intro": `LegalPage-intro-iBdaU`,
	"layout": `LegalPage-layout-R8mm6`,
	"layoutNarrow": `LegalPage-layoutNarrow-Qr92T`,
	"toc": `LegalPage-toc-js6aU`,
	"tocTitle": `LegalPage-tocTitle-fHJLm`,
	"body": `LegalPage-body-JLv8p`,
	"section": `LegalPage-section-xKjub`,
	"h2": `LegalPage-h2-pdrc5`,
	"subH": `LegalPage-subH-y3ppp`,
	"list": `LegalPage-list-mbIQp`,
	"note": `LegalPage-note-Co2Hu`
};
module.exports = ___CSS_LOADER_EXPORT___;
